<template>
    <v-tooltip transition="fade-transition" bottom max-width="280" color="tooltip" :close-delay="300" open-on-focus>
        <template v-slot:activator="{on, attrs}">
            <v-icon :size="large ? 24 : ( small ? 15 : 18)" class="info-icon" :color="dark ? 'white' : 'strong-text'" v-on="on" v-bind="attrs">
                mdi-information
            </v-icon>
        </template>
        <div class="py-1">
            <span v-if="text">{{text}}</span>
            <slot v-else />
        </div>
    </v-tooltip>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        text: {
            type: String
        },
        small: {
            type: Boolean,
            default: false,
        },
        dark: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {

        }
    },
    computed: {

        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    },
    created(){

    }
}
</script>

<style lang="scss" scoped>
    .info-icon{
        opacity: 0.5;
        // cursor: help!important;
        cursor: default!important;

        &:hover{
            opacity: 0.75;
        }
    }
</style>
